exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[data-v-488bbcc8] {\n  -webkit-transition: all 1s ease;\n  transition: all 1s ease;\n  cursor: pointer;\n  max-width: 300px;\n  height: auto;\n}\nimg[data-v-488bbcc8]:hover {\n  -webkit-transform: scale(1.1);\n          transform: scale(1.1);\n}\na[data-v-488bbcc8] {\n  font-weight: bold;\n}\nli[data-v-488bbcc8] {\n  margin-left: 1rem;\n}", ""]);

// exports
